module.exports = {
    WRITING_TRANSLATIONS_CATEGORY: {
        ID: '5',
        SLUG: 'writing-translation'
    },
    QUAILTY_TRANSLATIONS: {
        ID: '108',
        SLUG: 'quality-translation-services'
    }
};
